var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlidericonh2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.936,
    height: 150.936,
    viewBox: "0 0 150.936 150.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_111",
    x: 0,
    y: 0,
    width: 150.936,
    height: 150.936,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 7,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a7cafd",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(-3975.5 -2920)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3975.5, 2920)",
    filter: "url(#Rectangle_111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111-2",
    "data-name": "Rectangle 111",
    width: 94,
    height: 94,
    rx: 30,
    transform: "translate(13 68.47) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(4500.787 2602.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M-463.886,403.225c-3.659-.191-5.377-1.426-5.362-3.949a4.376,4.376,0,0,1,.744-2.374,4.536,4.536,0,0,1,2-1.473,10.607,10.607,0,0,1,2.564-.331v-5.281c-.415,0-.855.007-1.294,0a4,4,0,0,1-4.051-3.985,4,4,0,0,1,4.053-3.983c.422-.008.844,0,1.349,0v-5.312a13.832,13.832,0,0,1-2.363-.191,3.918,3.918,0,0,1-3.012-4.241,4.034,4.034,0,0,1,4.055-3.632c.4-.015.8,0,1.257,0,.055-.694.062-1.376.172-2.04A3.881,3.881,0,0,1-460.3,363.1a5.529,5.529,0,0,1,.71-.039q14.442,0,28.883,0a3.958,3.958,0,0,1,4.134,3,5.741,5.741,0,0,1,.123,1.478c.007,8.134,0,16.269.023,24.4a1.892,1.892,0,0,0,.415,1.126,9.437,9.437,0,0,1-5.249,15.351,10.461,10.461,0,0,1-2.121.172q-13.019.017-26.038.006a4.151,4.151,0,0,1-4.461-4.427C-463.888,403.873-463.886,403.571-463.886,403.225Zm34.791-12.5v-.786q0-11.206,0-22.411c0-1.379-.4-1.768-1.776-1.768-9.3,0-18.591.027-27.887-.019-2.408-.012-2.5.5-2.4,2.481a.957.957,0,0,0,.418.67,3.968,3.968,0,0,1,2.206,3.569,3.761,3.761,0,0,1-2.175,3.561.771.771,0,0,0-.474.827c.019,1.541.016,3.083,0,4.624a.747.747,0,0,0,.462.819,3.762,3.762,0,0,1,2.186,3.557,3.8,3.8,0,0,1-2.213,3.544.656.656,0,0,0-.437.689c.021,1.612-.009,3.226.029,4.837a.949.949,0,0,0,.43.676,3.9,3.9,0,0,1,2.192,3.571,3.94,3.94,0,0,1-2.24,3.616,1.061,1.061,0,0,0-.387.626,3,3,0,0,0-.015.779c.006,1.275.44,1.716,1.7,1.716q9.5,0,18.994,0c.225,0,.451-.019.719-.031a9.6,9.6,0,0,1-.992-12.029,9.415,9.415,0,0,1,4.3-3.372A9.364,9.364,0,0,1-429.095,390.725Zm2.641,8.48a6.6,6.6,0,0,0-6.645-6.682,6.641,6.641,0,0,0-6.654,6.618,6.668,6.668,0,0,0,6.662,6.762A6.63,6.63,0,0,0-426.454,399.2ZM-463.9,371.178c-.473,0-.947-.017-1.419,0a1.264,1.264,0,0,0-1.269,1.1,1.2,1.2,0,0,0,1,1.469,20.2,20.2,0,0,0,3.319.008,1.261,1.261,0,0,0,1.064-1.382,1.336,1.336,0,0,0-1.352-1.2C-463,371.163-463.447,371.177-463.9,371.178Zm-.052,29.3v0h1.348c.047,0,.095,0,.142,0a1.349,1.349,0,0,0,1.264-1.22,1.215,1.215,0,0,0-.95-1.323,20.831,20.831,0,0,0-3.521,0,1.173,1.173,0,0,0-.917,1.458,1.257,1.257,0,0,0,1.216,1.08C-464.895,400.5-464.42,400.483-463.948,400.483Zm-.018-13.347c.5,0,.994.018,1.489,0a1.328,1.328,0,0,0,1.286-1.333,1.314,1.314,0,0,0-1.279-1.266c-.969-.024-1.939-.026-2.908,0a1.224,1.224,0,0,0-1.212,1.293,1.235,1.235,0,0,0,1.206,1.3C-464.913,387.155-464.439,387.134-463.966,387.136Z",
    transform: "translate(0 0)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M-373.138,499.895c1.366-1.385,2.645-2.684,3.926-3.982.166-.169.329-.343.509-.5a1.336,1.336,0,0,1,1.861.028,1.318,1.318,0,0,1,0,1.857c-.833.875-1.7,1.715-2.557,2.571-.888.889-1.767,1.785-2.664,2.665a1.346,1.346,0,0,1-2.121,0q-1.42-1.395-2.814-2.816a1.353,1.353,0,0,1-.122-1.965,1.311,1.311,0,0,1,2.006.084C-374.457,498.484-373.836,499.165-373.138,499.895Z",
    transform: "translate(-78.737 -113.213)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M-373.141,574.834c1.434-1.447,2.764-2.8,4.105-4.134a2.982,2.982,0,0,1,.777-.6,1.276,1.276,0,0,1,1.575.459,1.31,1.31,0,0,1-.143,1.692c-1.107,1.138-2.24,2.25-3.363,3.374-.62.62-1.23,1.25-1.859,1.861a1.347,1.347,0,0,1-2.121-.011q-1.4-1.37-2.765-2.765a1.375,1.375,0,0,1-.162-2.017,1.331,1.331,0,0,1,2.057.143C-374.406,573.465-373.8,574.131-373.141,574.834Z",
    transform: "translate(-78.756 -177.479)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M-373.17,424.9c1.337-1.357,2.582-2.621,3.828-3.884.2-.2.394-.412.61-.6a1.336,1.336,0,0,1,1.861.01,1.307,1.307,0,0,1,.017,1.855q-2.665,2.714-5.378,5.38a1.265,1.265,0,0,1-1.856-.031q-1.535-1.481-3.017-3.015a1.321,1.321,0,0,1-.044-1.86,1.26,1.26,0,0,1,1.9-.026C-374.55,423.395-373.906,424.123-373.17,424.9Z",
    transform: "translate(-78.718 -48.875)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M-275.026,438.844c1.278,0,2.556-.007,3.834,0a1.37,1.37,0,0,1,1.5,1.343,1.368,1.368,0,0,1-1.5,1.277q-3.87.01-7.74,0a1.261,1.261,0,0,1-1.424-1.307,1.263,1.263,0,0,1,1.419-1.312C-277.63,438.835-276.328,438.844-275.026,438.844Z",
    transform: "translate(-162.053 -64.998)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M-275.106,516.479c-1.278,0-2.556.009-3.834,0a1.263,1.263,0,0,1-1.41-1.321,1.263,1.263,0,0,1,1.432-1.3q3.87-.012,7.74,0a1.365,1.365,0,0,1,1.489,1.286,1.372,1.372,0,0,1-1.511,1.335C-272.5,516.486-273.8,516.479-275.106,516.479Z",
    transform: "translate(-162.052 -129.335)",
    fill: "#543af4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M-221.7,591.537c.465,0,.841-.018,1.214,0a1.359,1.359,0,0,1,1.418,1.371,1.311,1.311,0,0,1-1.462,1.3c-.829.01-1.659.016-2.489,0a1.273,1.273,0,0,1-1.364-1.322c-.031-.876-.028-1.754,0-2.631a1.285,1.285,0,0,1,1.277-1.335,1.329,1.329,0,0,1,1.4,1.3C-221.668,590.616-221.7,591.02-221.7,591.537Z",
    transform: "translate(-210.04 -193.719)",
    fill: "#543af4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidericonh2);
export default __webpack_public_path__ + "static/media/slidericonh2.8225dbb2e323ca99157e5b2bb22e4e79.svg";
export { ForwardRef as ReactComponent };